import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  accordion: {
    padding: '8px 8px 66px 8px',
    '& .MuiAccordionSummary-root.Mui-focused': {
      background: 'white'
    }
  },
  accordionSummary: {
    position: 'static'
  },
  expandBtn: {
    padding: '5px 10px'
  },
  expandBtnIcon: {
    fontSize: 16,
    transition: 'all 0.4s'
  },
  fixedBtns: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    zIndex: 5,
    padding: '8px 16px !important'
  },
  mobileFilter: {
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))
